"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetPropertiesResponse = void 0;
const utils_1 = require("../../utils");
const PropertyDescriptor_1 = require("./PropertyDescriptor");
class GetPropertiesResponse {
    constructor(object, getObjectId) {
        this.result = Object.entries(object).map(([key, o]) => {
            var _a, _b;
            const objectId = (0, utils_1.isObject)(o) ? getObjectId(o) : undefined;
            const disc = Object.getOwnPropertyDescriptor(object, key);
            if (!disc) {
                throw new Error(`PropertyDescriptor of ${o} is missing`);
            }
            return new PropertyDescriptor_1.PropertyDescriptor(o, objectId, {
                name: key,
                enumerable: (_a = disc.enumerable) !== null && _a !== void 0 ? _a : true,
                configurable: (_b = disc.configurable) !== null && _b !== void 0 ? _b : true,
                writable: disc.writable,
            });
        });
    }
}
exports.GetPropertiesResponse = GetPropertiesResponse;
